const brandFormsStyle = `
  :is(h1, h2, h3, [class*="textHeading"], button) {
    font-family: "Cormorant Garamond", Georgia, serif !important;
    font-weight: 500 !important;
    letter-spacing: .01em !important;
  }
`;

function applyBrandTypographyToForms(root = document) {
  root.querySelectorAll('shopify-forms-embed').forEach((formsEmbed) => {
    const shadowRoot = formsEmbed.shadowRoot;

    if (!shadowRoot || shadowRoot.querySelector('[data-marcks-brand-typography]')) return;

    const style = document.createElement('style');
    style.dataset.marcksBrandTypography = '';
    style.textContent = brandFormsStyle;
    shadowRoot.append(style);
  });
}

function initializeBrandFormsTypography() {
  applyBrandTypographyToForms();

  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node instanceof Element) applyBrandTypographyToForms(node.matches('shopify-forms-embed') ? node.parentElement : node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  let attempts = 0;
  const retry = setInterval(() => {
    applyBrandTypographyToForms();
    attempts += 1;

    if (document.querySelector('shopify-forms-embed')?.shadowRoot?.querySelector('[data-marcks-brand-typography]') || attempts >= 40) {
      clearInterval(retry);
    }
  }, 500);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeBrandFormsTypography, { once: true });
} else {
  initializeBrandFormsTypography();
}
